export const validateEnum = (value, enumType) => {
  return Object.values(enumType).includes(value)
}
export const getPickerIcon = (isActive, type) => {
  return isActive
    ? { icon: `$vuetify.icons.${type}On`, color: 'primary' }
    : { icon: `$vuetify.icons.${type}Off`, color: 'grey' }
}
